import { render, staticRenderFns } from "./PollKeyboard.vue?vue&type=template&id=354d5a5b&"
import script from "./PollKeyboard.vue?vue&type=script&lang=js&"
export * from "./PollKeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports